import { render, staticRenderFns } from "./MyEvents.vue?vue&type=template&id=96e80e50&"
import script from "./MyEvents.vue?vue&type=script&lang=js&"
export * from "./MyEvents.vue?vue&type=script&lang=js&"
import style0 from "./MyEvents.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports